__turbopack_context__.v({
  "root": "Certification-module-scss-module__h_VPZG__root",
});
